module.exports = __webpack_public_path__ + "fonts/Raleway-Italic.cb2ed902.woff2";